module.exports = __webpack_public_path__ + "static/media/6.be3f96e2.JPG";